import { applicationApi } from "common/api";
import { AnswerQuestionaireRequest, QuestionaireResponse, StartQuestionaireRequest } from "models/flQuestionaire";

// Define a service using a base URL and expected endpoints
export const questionaireApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    answer: builder.mutation<QuestionaireResponse, AnswerQuestionaireRequest>({
      query: (body) => ({
        url: `bdc/questionaire`,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Questionaire", id: "Questionaire" }],
    }),
    get: builder.query<QuestionaireResponse, string>({
      query: (query) => `bdc/questionaire/${query}`,
      providesTags: [{ type: "Questionaire", id: "Questionaire" }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useAnswerMutation, useGetQuery } = questionaireApi;
